"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesChannel = void 0;
var SalesChannel;
(function (SalesChannel) {
    SalesChannel["ACCOUNTANT"] = "accountant";
    SalesChannel["DIRECT"] = "direct";
    SalesChannel["PARTNER"] = "partner";
})(SalesChannel || (exports.SalesChannel = SalesChannel = {}));
